<template>
  <div
    class="tools02-report-import-manual-send-conversion-event-system-smartnews-inputs"
  >
    <el-row v-if="type === 'default'" type="flex" align="middle">
      <el-col :span="3">プログラム名（※）</el-col>
      <el-col :span="10">
        <el-select v-model="promotionId" placeholder="選択してください。" clearable>
          <el-option
            v-for="promotionData in promotionList"
            :key="promotionData.promotionId"
            :label="promotionData.promotionName"
            :value="promotionData.promotionId"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle">
      <el-col :span="3">報酬額（※）</el-col>
      <el-col :span="4"
        ><el-input v-model="conversionData.value" type="number" min="0" clearable
      /></el-col>
    </el-row>
    <el-row type="flex" align="middle">
      <el-col :span="3">CV時間（※）</el-col>
      <el-col :span="10"
        ><el-date-picker
          v-model="conversionData.eventTime"
          type="datetime"
          value-format="timestamp"
          clearable
        >
        </el-date-picker
      ></el-col>
    </el-row>
    <el-row v-if="type === 'ctrl'" type="flex" align="middle">
      <el-col :span="3">CVイベント</el-col>
      <el-col :span="10"
        ><el-select v-model="conversionData.eventName" placeholder="選択してください。">
          <el-option
            v-for="smartnewsEventData in smartnewsEventList"
            :key="smartnewsEventData.id"
            :label="`${smartnewsEventData.name}（${smartnewsEventData.event}）`"
            :value="smartnewsEventData.event"
          >
          </el-option>
        </el-select
      ></el-col>
    </el-row>
    <el-row type="flex" align="middle">
      <el-col :span="3">click_id（※）</el-col>
      <el-col :span="18"
        ><el-input v-model="conversionData.clickId" clearable
      /></el-col>
    </el-row>
    <el-row type="flex" align="middle">
      <el-col :span="3">IPアドレス</el-col>
      <el-col :span="4"
        ><el-input v-model="conversionData.clientIpAddress" clearable
      /></el-col>
    </el-row>
    <el-row type="flex" align="middle">
      <el-col :span="3">User Agent</el-col>
      <el-col :span="18"
        ><el-input v-model="conversionData.clientUserAgent" clearable
      /></el-col>
    </el-row>
    <el-row v-if="type === 'ctrl'" type="flex" align="middle">
      <el-col :span="3">CVページURL</el-col>
      <el-col :span="18"><el-input v-model="conversionData.eventSourceUrl" clearable /></el-col>
    </el-row>
    <el-row>
      <el-col style="text-align: center">
        <el-button @click="sendConversionEvent" type="primary">送信</el-button>
      </el-col>
    </el-row>
    <el-row v-if="resultData !== undefined">
      <el-col>
        <h3>送信結果</h3>
        <div v-if="resultData.eventReceived === true">送信成功！</div>
        <div v-else>{{ resultData.errorMessage }}</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "tools02-report-import-manual-send-conversion-event-system-smartnews-inputs",
  components: {},
  props: {
    resultData: Object,
    type: String,
  },
  data() {
    return {
      tools02TagId: "",
      promotionId: "",
      conversionData: {
        eventName: "Purchase",
        eventTime: "",
        value: 0,
        currency: "JPY",
        clickId: "",
        clientIpAddress: "",
        clientUserAgent: "",
        eventSourceUrl: "",
      },
    };
  },
  computed: {
    ...mapGetters(["rt", "tool", "apiErrorMessage"]),
    ...mapGetters("tools02", ["smartnewsEventList"]),
    promotionList() {
      return this.$store.getters["tools02/promotionListByToolId"]("18");
    },
  },
  methods: {
    sendConversionEvent() {
      // 必須項目（※）のチェック。 プログラムは画面の利用者向け（default）のときだけ選ぶ
      if (
        this.conversionData.eventTime !== "" &&
        this.conversionData.eventTime !== null &&
        this.conversionData.clickId !== "" &&
        this.conversionData.value !== "" &&
        this.conversionData.value !== null
      ) {
        // ok.
      } else {
        alert("必須項目（※）を入力してください。");
        return;
      }
      if (this.type === "default") {
        if (this.promotionId !== "" && this.promotionId !== null) {
          // ok.
        } else {
          alert("必須項目（※）を入力してください。");
          return;
        }
      } else {
        // no action.
      }

      //
      const conversionData = JSON.parse(JSON.stringify(this.conversionData));

      // CV時間は日本時間で入力し、UNIX秒に直して送る
      conversionData.eventTime = Math.floor(conversionData.eventTime / 1000);

      // 選んだプログラムのCVイベントとCVページURLで送る（TikTok と同じ取り方）
      let promotionId = "0";
      if (this.type === "default") {
        const promotionData = this.$store.getters["tools02/promotionData"](
          this.promotionId
        );
        const smartnewsEventData = this.$store.getters["tools02/smartnewsEventData"](
          promotionData.smartnewsEventId
        );
        if (smartnewsEventData !== undefined) {
          // ok.
        } else {
          alert("選択したプログラムにCVイベントが設定されていません。プログラムの編集画面でCVイベントを選んでください。");
          return;
        }
        conversionData.eventName = smartnewsEventData.event;
        conversionData.eventSourceUrl = promotionData.cvPageUrl;
        promotionId = this.promotionId;
      } else {
        // no action.
      }

      //
      const payload = {
        tools02TagId: this.tools02TagId,
        promotionId: promotionId,
        conversionData: conversionData,
      };
      this.$emit("sendConversionEvent", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
